import { render, staticRenderFns } from "./FooterCurve.vue?vue&type=template&id=1a4b577c&scoped=true"
import script from "./FooterCurve.vue?vue&type=script&lang=js"
export * from "./FooterCurve.vue?vue&type=script&lang=js"
import style0 from "./FooterCurve.vue?vue&type=style&index=0&id=1a4b577c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b577c",
  null
  
)

export default component.exports